import React from 'react'
import Container from '../components/shared/container'

import Printer from '../components/printer'

function HomePage() {
  return (
    <Container>
      <Printer />
    </Container>
  )
}

export default HomePage
